import SectionButtonGroup from "../../../../../../components/Button/SectionButtonGroup"
import InfoMicroText from "./InfoMicroText";
import MoreInfoMicroText from "./MoreInfoMicroText"


export default function MicroButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "SEQUENCING INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Understand Your Mouth Microbiome Results"
      content_dialog_1 = {<InfoMicroText />}
      
      title_dialog_2 = "Metagenomics Shotgun Sequencing"
      content_dialog_2 = {<MoreInfoMicroText />}

      to = "/Doctor"

/>

</>
)}